export default __webpack_public_path__ + "static/media/information--trailer-camping--g1.742fd848.png";